import { SIMPANAN_HIBAH } from "../../constants/admin/masterdata/constants";

const initialState = {
  cache: {},
  queryKey: null,
  selectedIds: [],
  isModalAction: false,
  loadingGetSimpananHibah: true,
  loadingActionSimpananHibah: false,
  dataSimpananHibah: { count: 0, data: [] },
};

export const simpananHibahReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMPANAN_HIBAH.GET_DATA_SIMPANAN_HIBAH_SUCCESS:
      return {
        ...state,
        dataSimpananHibah: action.data,
      };

    case SIMPANAN_HIBAH.LOADING_DATA_SIMPANAN_HIBAH_SUCCESS:
      return {
        ...state,
        loadingGetSimpananHibah: action.load,
      };

    case SIMPANAN_HIBAH.LOADING_ACTION_SIMPANAN_HIBAH:
      return {
        ...state,
        loadingActionSimpananHibah: action.load,
      };

    case SIMPANAN_HIBAH.IS_MODAL_ACTION_SIMPANAN_HIBAH:
      return {
        ...state,
        isModalAction: action.load,
      };

    case SIMPANAN_HIBAH.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case SIMPANAN_HIBAH.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case SIMPANAN_HIBAH.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case SIMPANAN_HIBAH.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    case SIMPANAN_HIBAH.SET_CACHE_ENTRY: {
      const { key, data } = action;
      return {
        ...state,
        cache: {
          ...state.cache,
          [key]: { data, fetchedAt: Date.now(), loading: false },
        },
        dataSimpananHibah: data,
        loadingGetSimpananHibah: false,
      };
    }

    case SIMPANAN_HIBAH.SET_LOADING_FOR_KEY: {
      const { key, loading } = action;
      const prev = state.cache[key] || {};
      return {
        ...state,
        cache: { ...state.cache, [key]: { ...prev, loading } },
        loadingGetSimpananHibah: loading,
      };
    }

    case SIMPANAN_HIBAH.UPDATE_CACHE_ITEMS: {
      const { changesById } = action; 
      const nextCache = {};
      for (const k in state.cache) {
        const entry = state.cache[k];
        if (!entry?.data?.data) {
          nextCache[k] = entry;
          continue;
        }
        const newList = entry.data.data.map((row) =>
          changesById[row.id] ? { ...row, ...changesById[row.id] } : row
        );
        nextCache[k] = {
          ...entry,
          data: { ...entry.data, data: newList },
        };
      }
      const activeList = state.dataSimpananHibah?.data || [];
      const newActive = activeList.map((row) =>
        changesById[row.id] ? { ...row, ...changesById[row.id] } : row
      );
      return {
        ...state,
        cache: nextCache,
        dataSimpananHibah: {
          ...state.dataSimpananHibah,
          data: newActive,
        },
      };
    }

    default:
      return state;
  }
};
